import {Paper} from '@mui/material'
import {styled} from '@mui/system'

// NOTE: dimensions are fixed px values (not theme.spacing(n)) on purpose.
// This component is shared by legacy pages and new-style pages, whose themes
// use different spacing base units (legacy: 2, new: 8). Using theme.spacing(n)
// made the pagination controls balloon to ~4x their intended size when rendered
// inside ThemeProviderNew (e.g. PatientLookupDialog's patient table).
export const TableCustomStyled = styled(Paper)(({theme}) => ({
  width: '100%',
  overflow: 'hidden',
  borderRadius: 0,

  '& .MuiTableCell-head': {
    height: 20,
    padding: '10px 16px',
    fontWeight: 'bold',
    backgroundColor: theme.palette.background.default,
    textTransform: 'UPPERCASE',
    WebkitPrintColorAdjust: 'exact',
    borderRight: `1px solid ${theme.palette.divider}`,

    '& .MuiTableSortLabel-icon': {
      height: 24,
      width: 24
    },

    '&[colspan]': {
      textAlign: 'center',
      borderBottom: '2px solid',
      borderBottomColor: theme.palette.divider,
      backgroundColor: theme.palette.grey[100]
    }
  },

  '& .MuiTableBody-root': {
    border: 'solid 1px #dee5e7',

    '& .MuiTableCell-body': {
      height: 20,
      padding: '13px',
      color: theme.palette.neutral.main
    },

    '& .MuiTableRow-root:hover': {
      backgroundColor: theme.palette.primary[100]
    }
  },

  '& .MuiTablePagination-toolbar': {
    display: 'flex',
    justifyContent: 'center',

    '& .MuiInputBase-root': {
      order: 4,
      position: 'absolute',
      right: '0',

      '& .MuiTablePagination-select': {
        border: 'solid 1px',
        borderColor: theme.palette.neutral[200],
        borderRadius: 42,
        fontWeight: 600,
        color: theme.palette.neutral.main,
        height: 40,
        width: 44,
        padding: '0 30px !important',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },

    '& .MuiTablePagination-displayedRows': {
      display: 'flex',
      order: 1,
      marginTop: '1em',

      '.page-info': {
        display: 'flex',
        alignItems: 'center',

        '.page-counter': {
          margin: 8,
          padding: 12,
          border: 'solid 1px',
          borderColor: theme.palette.neutral[200],
          borderRadius: 42,
          color: theme.palette.neutral.main,
          height: 42,
          fontSize: 14,
          fontWeight: 500
        },

        '.total-elements': {
          margin: 8,
          color: theme.palette.neutral.main,
          fontSize: 14,
          fontWeight: 500
        }
      }
    },

    '& .MuiPagination-root': {
      order: 0,

      '& .MuiPagination-ul': {
        li: {
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 600,
          color: theme.palette.neutral.main,
          border: 'solid 1px',
          margin: 4,
          borderColor: theme.palette.neutral[200],
          borderRadius: 42,
          height: 42,
          width: 60,

          '& .Mui-selected': {
            height: 42,
            width: 60,
            borderRadius: 42,
            color: 'white',
            backgroundColor: theme.palette.primary.main,
            padding: 0,
            margin: 0
          }
        }
      }
    },

    '& .MuiTablePagination-spacer': {
      display: 'none'
    },

    '& .MuiTablePagination-selectLabel': {
      display: 'none'
    }
  }

}))
